var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { TableRow as MuiTableRow, TableCell as MuiTableCell } from '@mui/material';
import colors from '../../themes/colors';
var StyledMuiRow = styled(MuiTableRow)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  margin: 0;\n  padding: 0;\n  border: 0;\n"], ["\n  background-color: ", ";\n  margin: 0;\n  padding: 0;\n  border: 0;\n"])), colors.neutral5);
var StyledMuiCell = styled(MuiTableCell)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var StyledContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  overflow: hidden;\n  ", "\n"], ["\n  display: flex;\n  overflow: hidden;\n  ", "\n"])), function (_a) {
    var open = _a.open;
    if (open) {
        return "\n        height: auto;\n        padding: 16px\n      ";
    }
    return "\n      height: 0;\n      padding: 0;\n    ";
});
export default function TableExpandableRow(props) {
    var _a;
    var index = props.index, collapsedRows = props.collapsedRows, config = props.config, row = props.row;
    var isCollapsed = collapsedRows[index];
    var content = (_a = config === null || config === void 0 ? void 0 : config.onRowExpand) === null || _a === void 0 ? void 0 : _a.call(config, { index: index, row: row });
    if (!content)
        return null;
    if (!isCollapsed)
        return null;
    return (_jsx(StyledMuiRow, { children: _jsx(StyledMuiCell, __assign({ colSpan: 999 }, { children: _jsx(StyledContainer, __assign({ open: isCollapsed }, { children: content })) })) }));
}
var templateObject_1, templateObject_2, templateObject_3;
